import React, { useEffect, useRef, useState } from "react";
import { format, isToday, isAfter, parseISO } from "date-fns";
import axios from "axios";

import { ENDPOINTS } from "../../../js/api/_config";
import SecondaryButton from "../../common/buttons/SecondaryButton";
import { convertUTCToLocal } from "../../common/constant/constant";
import { CallCalendarIcon } from "../../../assets/icons/call-icon-calendar";
import useMediaQuery from "../../common/custom-hooks/use-media-query";
import { useSelector } from "react-redux";
import { MessageCalendarIcon } from "../../../assets/icons/message-icon-calendar";
import { useNavigate } from "react-router";

const EventPopup = ({
  event,
  position,
  onClose,
  cancelEvent,
  cancelMeeting,
  calOpen,
  setCalOpen,
  setMeetId,
  closePopup,
  setTrialInfo,
  handleCall,
}) => {
  const isMxDesktop = useMediaQuery("(min-width: 2560px)");
  const isSmMxDesktop = useMediaQuery("(min-width: 1905px)");
  const isLapi = useMediaQuery("(min-width: 1536px)");
  const isCallInProgress = useSelector((state) => state.call.callData);
  const [showDiv, setShowDiv] = useState(true);
  const lastScrollY = useRef(window.scrollY);
  const navigate = useNavigate();
  console.log("event", event);
  function getCallStatus(statusCode) {
    const statusMap = {
      completed: "Call Completed",
      "no-answer": "Call Not Answered",
      null: "Call Not Initiated",
      failed: "Call Failed",
    };

    const statusMessage = statusMap[statusCode];

    if (statusMessage) {
      return statusMessage;
    } else {
    }
  }
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (Math.abs(currentScrollY - lastScrollY.current) > 10) {
        setShowDiv(false);
      }

      lastScrollY.current = currentScrollY; // Update lastScrollY after checking
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  if (!showDiv) return null;

  const {
    patientName,
    phoneNumber,
    startTime,
    endTime,
    trialName,
    recruiterName,
    isOpen,
    calendarEventID,
  } = event;
  setTrialInfo(event);

  const LocStartTime = convertUTCToLocal(startTime);
  const LocEndTime = convertUTCToLocal(endTime);

  // Format event time
  // const formatEventTime = (start, end) => {
  //   const startDate = new Date(start);
  //   const endDate = new Date(end);
  //   return `From ${format(startDate, "MMMM dd, yyyy hh:mm a")} to ${format(endDate, "hh:mm a")}.`;
  // };

  // Extract initials
  const getInitials = (name) => {
    return name
      ? name
          .split(" ")
          .map((n) => n[0])
          .join("")
          .toUpperCase()
      : "";
  };

  // Check if event is for future after the current time
  const now = new Date();
  const eventStart = parseISO(startTime);
  const eventEnd = parseISO(endTime);

  const isEventUpcoming = isAfter(eventStart, now);

  const setEventToCancel = (id) => {
    setCalOpen(true);
    setMeetId(id);
  };

  function isPastDateTime(startTime) {
    const utcDate = new Date(
      startTime.endsWith("Z") ? startTime : `${startTime}Z`
    );

    // Now it’s correctly interpreted as UTC and converted to local browser time
    const currentDate = new Date();

    return utcDate < currentDate;
  }

  if (!event) return null;

  if (!position) return null;
  // console.log("testingPosition", {
  //   left:
  //     position.left + 420 > window.innerWidth ? "auto" : position.left + 100,
  //   right: position.left + 500 > window.innerWidth ? "30px" : "auto",
  //   top: position.top + 420 > window.innerHeight ? "auto" : position.top - 200,
  //   bottom: position.top + 420 > window.innerHeight ? "30px" : "auto",
  //   height: "420px",
  // });

  return (
    <>
      <div
        className={`absolute bg-white rounded-md shadow-lg p-5 w-[400px] border border-gray-300 `}
        style={
          !position && position
            ? { display: "none" }
            : {
                left:
                  position.left + 420 > window.innerWidth
                    ? "auto"
                    : position.left +
                      (isMxDesktop ? 50 : isSmMxDesktop ? 0 : 100),
                right:
                  position.left + 500 > window.innerWidth ? "30px" : "auto",
                top:
                  position.top + 420 > window.innerHeight
                    ? "auto"
                    : position.top - 200,
                bottom:
                  position.top + 420 > window.innerHeight ? "30px" : "auto",
                height: "420px",
              }
        }
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
        >
          ✕
        </button>

        {/* Patient Info */}
        <div
          className={`${
            isPastDateTime(event.endTime) && isOpen === true
              ? "patient-info-green"
              : isOpen === false
              ? "patient-info-red"
              : "patient-info"
          } pl-3 mb-5 w-full rounded-md`}
        >
          <p
            className={`popupMainTitle ${
              isPastDateTime(event.endTime) && isOpen === true
                ? "green_color"
                : isOpen === false
                ? "red_color line-through"
                : "blue_color"
            }`}
          >
            {patientName} - {phoneNumber}
          </p>
          <p
            className={`popupSubMainTitle ${
              isOpen === false ? "line-through" : ""
            }`}
          >
            From {LocStartTime.dateOnly} {LocStartTime.timeHHmm} to{" "}
            {LocEndTime.timeHHmm}.
          </p>
        </div>

        {/* Scheduled/Cancelled Status */}
        <div className="w-full mb-5 flex">
          <div
            className={`popup-bubble ${
              isPastDateTime(event.endTime) && isOpen === true
                ? event.callStatus === "completed" && isOpen === true
                  ? "completed_bubble"
                  : event.callStatus == null && isOpen === true
                  ? "not_initiated_bubble"
                  : event.callStatus === "failed" && isOpen === true
                  ? "call_failed_bubble"
                  : isOpen
                  ? "cancel_bubble"
                  : ""
                : isOpen
                ? "Scheduled_bubble"
                : "cancel_bubble"
            }`}
          >
            {isPastDateTime(event.endTime) && isOpen === true
              ? getCallStatus(event.callStatus)
              : isOpen
              ? "Scheduled"
              : "Cancelled"}
          </div>
          {isPastDateTime(event.endTime) || !isOpen ? (
            ""
          ) : (
            <button className={`ml-4`}>
              <button
                disabled={event.isCallInProgress}
                className={event.isCallInProgress ? `cursor-not-allowed` : ``}
                onClick={() => {
                  // setCallingModal(event.phoneNumber);
                  handleCall(event.phoneNumber);
                  // setIsChat(false);
                }}
              >
                <CallCalendarIcon />
              </button>
            </button>
          )}
          
          {event.patientTrialJuncID && (
            <button className={`ml-4`}>
              <button
                onClick={() => {
                  navigate(
                    `/conversation-list/${event.patientTrialJuncID}?conversation_type=all`
                  );
                }}
                className={`${isPastDateTime(event.endTime) ? "mt-[2px]" : ""}`}
              >
                <MessageCalendarIcon />
              </button>
            </button>
          )}
        </div>

        {/* Trial Name */}
        <div className="popupTitle w-full mb-4">{trialName}</div>
        {/* Recruiter Info */}
        <div className="w-full mb-4">
          <p className="regularTitle text-gray-600">Recruiter</p>
          <div className="w-full flex items-center mt-1">
            <div className="recruiter-intials other">
              {getInitials(recruiterName)}
            </div>
            <span className="ml-3 regularText">{recruiterName}</span>
          </div>
        </div>

        {/* Patient Info */}
        <div className="w-full mb-4">
          <p className="regularTitle text-gray-600">Patient</p>
          <div className="w-full flex items-center mt-1">
            <div className="recruiter-intials">{getInitials(patientName)}</div>
            <span className="ml-3 regularText">{patientName}</span>
          </div>
        </div>

        {/* Cancel Event Button - Only show if event is today and in current time */}
        {!isPastDateTime(event.startTime) && isOpen && (
          <div className="w-full">
            <button
              onClick={() => setEventToCancel(calendarEventID)}
              className="popupLink"
            >
              Cancel Event
            </button>
          </div>
        )}
      </div>

      {calOpen && (
        <div className="fixed w-full h-full inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg max-w-md w-full p-6 relative">
            <div>
              <div>
                <div className="flex flex-row mt-2 text-sm items-center">
                  <span className="delete-popup-bg item-center w-[50px!important]">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="26"
                      height="26"
                      viewBox="0 0 26 26"
                      fill="none"
                    >
                      <path
                        d="M24.5827 13.0026C24.5827 12.5884 24.2469 12.2526 23.8327 12.2526C23.4185 12.2526 23.0827 12.5884 23.0827 13.0026H24.5827ZM19.5004 4.33594L19.0499 4.93556V4.93556L19.5004 4.33594ZM21.666 6.50155L21.0664 6.95205L21.0975 6.99343L21.1339 7.03014L21.666 6.50155ZM23.2148 1.08259C23.2129 0.668382 22.8756 0.334097 22.4614 0.335945C22.0472 0.337793 21.7129 0.675074 21.7148 1.08928L23.2148 1.08259ZM22.4744 3.23713L23.2244 3.23378V3.23378L22.4744 3.23713ZM18.4877 7.22379L18.4843 7.97379L18.4877 7.22379ZM16.3398 6.4642C15.9256 6.46236 15.5884 6.79664 15.5865 7.21085C15.5847 7.62506 15.9189 7.96234 16.3332 7.96419L16.3398 6.4642ZM22.0318 6.39716L22.6249 6.85618V6.85618L22.0318 6.39716ZM21.6477 6.7812L22.1067 7.37433L22.1067 7.37433L21.6477 6.7812ZM23.0827 13.0026C23.0827 18.5715 18.5682 23.0859 12.9993 23.0859V24.5859C19.3966 24.5859 24.5827 19.3999 24.5827 13.0026H23.0827ZM12.9993 23.0859C7.43048 23.0859 2.91602 18.5715 2.91602 13.0026H1.41602C1.41602 19.3999 6.60205 24.5859 12.9993 24.5859V23.0859ZM2.91602 13.0026C2.91602 7.43373 7.43048 2.91927 12.9993 2.91927V1.41927C6.60205 1.41927 1.41602 6.60531 1.41602 13.0026H2.91602ZM12.9993 2.91927C15.2706 2.91927 17.3646 3.66932 19.0499 4.93556L19.9509 3.73632C18.0147 2.28161 15.6066 1.41927 12.9993 1.41927V2.91927ZM19.0499 4.93556C19.8133 5.50915 20.4928 6.18861 21.0664 6.95205L22.2656 6.05104C21.6072 5.17464 20.8273 4.39477 19.9509 3.73632L19.0499 4.93556ZM21.7148 1.08928L21.7244 3.24047L23.2244 3.23378L23.2148 1.08259L21.7148 1.08928ZM18.491 6.4738L16.3398 6.4642L16.3332 7.96419L18.4843 7.97379L18.491 6.4738ZM21.7244 3.24047C21.7283 4.11587 21.7298 4.70905 21.6806 5.15902C21.6332 5.59391 21.5463 5.79905 21.4386 5.93814L22.6249 6.85618C22.9713 6.40853 23.1096 5.89143 23.1718 5.32186C23.2323 4.76739 23.2281 4.07391 23.2244 3.23378L21.7244 3.24047ZM18.4843 7.97379C19.3245 7.97753 20.018 7.98176 20.5724 7.92121C21.142 7.85901 21.6591 7.72076 22.1067 7.37433L21.1887 6.18807C21.0496 6.29571 20.8445 6.38259 20.4096 6.43008C19.9596 6.47922 19.3664 6.47771 18.491 6.4738L18.4843 7.97379ZM21.4386 5.93814C21.3942 5.99551 21.3455 6.04926 21.2929 6.09895L22.3227 7.18957C22.4318 7.08654 22.5329 6.9751 22.6249 6.85618L21.4386 5.93814ZM21.2929 6.09895C21.2597 6.13031 21.2249 6.16006 21.1887 6.18807L22.1067 7.37433C22.1818 7.31625 22.2539 7.25459 22.3227 7.18957L21.2929 6.09895ZM21.1339 7.03014L21.2757 7.17285L22.3399 6.11567L22.1981 5.97296L21.1339 7.03014Z"
                        fill="#DC3545"
                      />
                      <path
                        d="M15.3459 11.7593C15.3459 13.0545 14.2959 14.1045 13.0007 14.1045V15.6045C15.1243 15.6045 16.8459 13.883 16.8459 11.7593H15.3459ZM13.0007 14.1045C11.7054 14.1045 10.6554 13.0545 10.6554 11.7593H9.15541C9.15541 13.883 10.877 15.6045 13.0007 15.6045V14.1045ZM10.6554 11.7593C10.6554 10.4641 11.7054 9.41406 13.0007 9.41406V7.91406C10.877 7.91406 9.15541 9.63563 9.15541 11.7593H10.6554ZM13.0007 9.41406C14.2959 9.41406 15.3459 10.4641 15.3459 11.7593H16.8459C16.8459 9.63563 15.1243 7.91406 13.0007 7.91406V9.41406ZM10.6792 17.926H15.3221V16.426H10.6792V17.926ZM15.3221 22.6164H10.6792V24.1164H15.3221V22.6164ZM10.6792 22.6164C9.38398 22.6164 8.33398 21.5664 8.33398 20.2712H6.83398C6.83398 22.3949 8.55556 24.1164 10.6792 24.1164V22.6164ZM17.6673 20.2712C17.6673 21.5664 16.6173 22.6164 15.3221 22.6164V24.1164C17.4457 24.1164 19.1673 22.3949 19.1673 20.2712H17.6673ZM15.3221 17.926C16.6173 17.926 17.6673 18.976 17.6673 20.2712H19.1673C19.1673 18.1475 17.4457 16.426 15.3221 16.426V17.926ZM10.6792 16.426C8.55556 16.426 6.83398 18.1475 6.83398 20.2712H8.33398C8.33398 18.976 9.38398 17.926 10.6792 17.926V16.426Z"
                        fill="#DC3545"
                      />
                    </svg>
                  </span>
                  <span>Are you sure want to delete the meeting?</span>
                </div>
              </div>

              <div className="flex flex-row justify-end gap-5 mt-5">
                <button
                  className="px-5 py-1 text-base rounded-md border primary_btn transition-all duration-500 red_btn"
                  onClick={cancelMeeting}
                >
                  Yes
                </button>
                <SecondaryButton onClick={closePopup} label="Cancel" />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default EventPopup;
